module.exports = __webpack_public_path__ + "img/img_guide_delete_account_1.31c15819.png";